<template>
	<div>
        <b-row>
            <b-col>
                <b-form-group :label="$t('semester')">
                    <div class="label-as-input">{{ isNotNullValue(formData.semester_name) }}</div>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group :label="$t('program_code')">
                    <div class="label-as-input">{{ isNotNullValue(formData.program_code)}}</div>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group :label="$t('exam')">
                    <div class="label-as-input">{{ isNotNullValue(formData.exam_name)}}</div>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group :label="$t('rate')">
                    <div class="label-as-input">{{ isNotNullValue(formData.rate)}}</div>
                </b-form-group>
            </b-col>
        </b-row>
	</div>
</template>

<script>
// Components

// Services
import FashionDesignService from "@/services/FashionDesignService"

// Other
export default {
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {},
            formLoading: false,
        }
    },

    created() {
        console.log('created')
        this.get(this.formId)
    },
    methods: {
        get(id) {
            FashionDesignService.getExamType(id).then(response => {
                this.formData = response.data.data
            }).catch(e => {
                this.showErrors(e)
            })
        },


    }
}
</script>
